(function() {
	'use strict';

	angular
		.module('components')
		.component('expandableInformation', {
			bindings: {
				analyticsCategory: '@',
				analyticsLabel: '@',
				defaultOpen: '<',
				hideIcon: '<',
				icon: '<',
				onClose: '&',
				onOpen: '&',
				title: '<'
			},
			controller: 'ExpandableInformationComponentController',
			controllerAs: 'vm',
			templateUrl: 'scripts/components/expandable-information/expandable-information-component.html',
			transclude: true
		});
}());
